export default function getReqErrorMessage(error, fallbackMsg = 'Something went wrong') {
    if (!error) {
        return fallbackMsg;
    }
    return (error.graphQLErrors[0]?.message ??
        error.clientErrors[0]?.message ??
        error.networkError?.message ??
        error.message ??
        fallbackMsg);
}
